module.exports = __webpack_public_path__ + "img/lb-dark.d556552c.svg";